<template>
  <div class="page_main">
    <div>
      <div class="page_title">
        连表头一并粘贴，从第二行开始每行一个银行卡号，默认从第二行计算
      </div>
    </div>

    <div>
      <TablePaste 
        :input-props="inputProps"
        @on-success="handleSuccess"
        @on-error="handleError"
        ref="table"
      />
    </div>
    <div class="box2" >
        <Spin  fix v-if="loading" />

      <div class="exprt_1">
        <span class="exprt" @click="export_excel"><Icon type="ios-cloud-download-outline" />导出表格</span>
      </div>
      <Table ref="table2" size="small" :columns="columns" :data="table_data"></Table>
    </div>
  </div>
</template>

<script>
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";

export default {
  data() {
    return {
      bank_card_list: [],
      table_data: [],
      columns: [],
      inputProps: [],
      object_name:'',
      loading:false
    };
  },
  methods: {
    export_excel() {
    //   this.$refs.table2.exportCsv({
    //     filename: "银行卡信息表",
    //   });
      get_view_file_url(this.object_name)
    },

    handleSuccess(e) {
      console.log(e);
      var bankcard_list = [];
      for (var i = 0; i < e.data.length; i++) {
        var bankcard = e.data[i]["key0"];
        console.log(bankcard);
        bankcard_list.push(bankcard);
      }
      if(bankcard_list.length==0){
        return
      }

      this.bank_card_list = bankcard_list;


      this.get_data();
    },

    handleError(e) {
      console.log(e);
    },

    // 获取
    get_data() {
      var that = this;
      var obj = {
        bank_card_list: this.bank_card_list,
      };
      this.loading =true
      http(
        "post",
        process.env.VUE_APP_HOST + "/finance/payment/get_bank_card_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.columns = res.data.columns;
            that.table_data = res.data.table_data;
            that.object_name = res.data.object_name
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          this.loading =false

        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.exprt_1 {
  display: flex;
  justify-content: flex-end;
}

.exprt {
  color: #0466dd;
  cursor: pointer;
}

.box2 {
  background: #fff;
  padding: 10px;
  position: relative;
  margin-top: 20px;
}

.page_title {
  padding-bottom: 10px;
}

.page_main {
  padding: 10px;
  background: #ececec;
}
</style>
